import { render, staticRenderFns } from "./AdminConfirmForm.vue?vue&type=template&id=524263e9&scoped=true&"
import script from "./AdminConfirmForm.vue?vue&type=script&lang=ts&"
export * from "./AdminConfirmForm.vue?vue&type=script&lang=ts&"
import style0 from "./AdminConfirmForm.vue?vue&type=style&index=0&id=524263e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524263e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VRow,VTextField})
